import { render, staticRenderFns } from "./PageSelector.vue?vue&type=template&id=7dccb4b2&"
import script from "./PageSelector.vue?vue&type=script&lang=ts&"
export * from "./PageSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports